import { NavigationContainer } from '@react-navigation/native';
import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import {
  RouteScreens,
  MarisaServices,
  AppOriginType,
} from '@bamse-digital/marisa-servicos';
import { useFonts } from 'expo-font';
import { useWebDocumentHeight } from './utils/useWebDocumentHeight';
import { getQueryParams } from './utils/getQueryParams';
import './styles';
import { getDeviceInfo } from './utils/getDeviceInfo';
import * as Clipboard from 'expo-clipboard';

export default function App() {
  const [fontsLoaded] = useFonts({
    PlutoSansMedium: require('../assets/fonts/PlutoSansMedium.otf'),
    PlutoSansBold: require('../assets/fonts/PlutoSansBold.otf'),
    PlutoSansRegular: require('../assets/fonts/PlutoSansRegular.otf'),
    PlutoSansLight: require('../assets/fonts/PlutoSansLight.otf'),
  });
  const authTokenRef = React.useRef<string>();
  const originRef = React.useRef<AppOriginType | null>(null);
  const deviceIdRef = React.useRef<string | null | undefined>(null);
  const deviceModelRef = React.useRef<string | null | undefined>(null);
  const OSIdRef = React.useRef<string | null | undefined>(null);
  const OSVersionRef = React.useRef<string | null | undefined>(null);

  useWebDocumentHeight();

  if (!fontsLoaded) {
    return null;
  }

  const params = getQueryParams();
  const deviceInfo = getDeviceInfo();
  authTokenRef.current = params.authToken;
  originRef.current = params.origin;
  deviceIdRef.current = deviceInfo.deviceId;
  deviceModelRef.current = deviceInfo.deviceModel;
  OSIdRef.current = deviceInfo.OSId;
  OSVersionRef.current = deviceInfo.OSVersion;

  return (
    <View style={styles.container}>
      <NavigationContainer
        linking={{
          prefixes: [],
          config: {
            initialRouteName: 'MarisaServicos_Home',
            screens: RouteScreens,
          },
        }}
      >
        <MarisaServices
          origin={originRef.current}
          authToken={authTokenRef.current}
          deviceId={deviceIdRef.current}
          deviceModel={deviceModelRef.current}
          OSId={OSIdRef.current}
          OSVersion={OSVersionRef.current}
          copyToClipboard={async (value) =>
            await Clipboard.setStringAsync(value)
          }
          disableConsortium
          disableInsurance={true}
          disableMbank={false}
        />
      </NavigationContainer>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
